import { useEffect, useState } from 'react';
import AnneescolaireService from '../../../services/AnneescolaireService';

const useYear = () => {
	const [yearOptions, setYearOptions] = useState([]);
	const [selectedYear, setSelectedYear] = useState({});

	useEffect(() => {
		const fetchYearOptions = async () => {
			try {
				const years = await AnneescolaireService.getYearOptions();
				setYearOptions(years);

				const currentYear =
					await AnneescolaireService.getCurrentAnneescolaire();
				setSelectedYear(currentYear.data);
			} catch (error) {
				console.error('Error fetching year options', error);
			}
		};

		fetchYearOptions();
	}, []);

	const handleYearChange = async (yearId) => {
		try {
			const year = await AnneescolaireService.getAnneescolaire(yearId);
			setSelectedYear(year.data || {});
		} catch (error) {
			console.error('Error fetching year or trimester', error);
		}
	};

	return {
		yearOptions,
		selectedYear,
		handleYearChange
	};
};

export default useYear;
